module.exports = __webpack_public_path__ + "img/united3-cover-1.ba139709.jpg";